import { render } from "./ViewCustomers.vue?vue&type=template&id=5e09d301&scoped=true"
import script from "./ViewCustomers.vue?vue&type=script&lang=js"
export * from "./ViewCustomers.vue?vue&type=script&lang=js"

import "./ViewCustomers.vue?vue&type=style&index=0&id=5e09d301&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e09d301"]])

export default __exports__